import type { FontFamilyPresetPair } from '@sites/site-theme/src/types';
import { ThemeFontFamilies } from '@sites/site-theme/src/enums/font-families.enum';

export const DEFAULT_FONT_FAMILY_PRESET_PAIRS: FontFamilyPresetPair[] = [
    {
        header: ThemeFontFamilies.montserrat,
        paragraph: ThemeFontFamilies.montserrat,
    },
    {
        header: ThemeFontFamilies.ptSans,
        paragraph: ThemeFontFamilies.ptSans,
    },
    {
        header: ThemeFontFamilies.firaSans,
        paragraph: ThemeFontFamilies.firaSans,
    },
    {
        header: ThemeFontFamilies.ibmPlexSans,
        paragraph: ThemeFontFamilies.ibmPlexSans,
    },
    {
        header: ThemeFontFamilies.openSans,
        paragraph: ThemeFontFamilies.openSans,
    },
    {
        header: ThemeFontFamilies.comfortaa,
        paragraph: ThemeFontFamilies.comfortaa,
    },
    {
        header: ThemeFontFamilies.manrope,
        paragraph: ThemeFontFamilies.manrope,
    },
    {
        header: ThemeFontFamilies.lora,
        paragraph: ThemeFontFamilies.lora,
    },
    {
        header: ThemeFontFamilies.merriweather,
        paragraph: ThemeFontFamilies.merriweather,
    },
    {
        header: ThemeFontFamilies.jost,
        paragraph: ThemeFontFamilies.jost,
    },
    {
        header: ThemeFontFamilies.unbounded,
        paragraph: ThemeFontFamilies.unbounded,
    },
    {
        header: ThemeFontFamilies.pacifico,
        paragraph: ThemeFontFamilies.openSans,
    },
    {
        header: ThemeFontFamilies.lora,
        paragraph: ThemeFontFamilies.roboto,
    },
    {
        header: ThemeFontFamilies.ptSerif,
        paragraph: ThemeFontFamilies.ptSans,
    },
    {
        header: ThemeFontFamilies.bitter,
        paragraph: ThemeFontFamilies.raleWay,
    },
    {
        header: ThemeFontFamilies.merriweather,
        paragraph: ThemeFontFamilies.firaSans,
    },
    {
        header: ThemeFontFamilies.openSans,
        paragraph: ThemeFontFamilies.lora,
    },
    {
        header: ThemeFontFamilies.ibmPlexSans,
        paragraph: ThemeFontFamilies.ibmPlexSerif,
    },
    {
        header: ThemeFontFamilies.oswald,
        paragraph: ThemeFontFamilies.playFairDisplay,
    },
    {
        header: ThemeFontFamilies.comfortaa,
        paragraph: ThemeFontFamilies.sourceCodeProp,
    },
    {
        header: ThemeFontFamilies.manrope,
        paragraph: ThemeFontFamilies.anonymousPro,
    },
    {
        header: ThemeFontFamilies.ibmPlexSerif,
        paragraph: ThemeFontFamilies.ibmPlexSans,
    },
    {
        header: ThemeFontFamilies.balsamiqSans,
        paragraph: ThemeFontFamilies.openSans,
    },
    {
        header: ThemeFontFamilies.jost,
        paragraph: ThemeFontFamilies.ubuntu,
    },
];
